module.exports = __webpack_public_path__ + "img/sololearnCSS.c9b77063.webp";